// @ts-check
import AppStore from "Stores/AppStore";
import usersServerSettingsStore from "Stores/usersServerSettingsStore";

export const UsersServerSettingsItems = () => {
    let isDisabled = usersServerSettingsStore.settingsLoading;

    let initData = AppStore.isMeeting
        ? [
            { id: 'application-update-block', text: 'Обновление', icon: 'uss-app-update' },
            { id: 'notification-block', text: 'Уведомления', icon: 'uss-notification' }
        ]
        : [
            { id: 'stoplist-block', text: 'Стоп-лист', icon: 'stop-list-menu' },
            { id: 'application-eds-block', text: 'Электронная подпись', icon: 'us-eds-menu' },
            { id: 'application-update-block', text: 'Обновление', icon: 'uss-app-update' },
            { id: 'notification-block', text: 'Уведомления', icon: 'uss-notification' },
            { id: 'sync-settings-block', text: 'Синхронизация', icon: 'us-sync-menu' },
            { id: 'organization-logo-settings-block', text: 'Оформление', icon: 'uss-decoration' }
        ];

    let result = initData.map((item) =>
    ({
        id: item.id,
        linkTo: "#" + item.id,
        title: item.text,
        icon: item.icon,
        isDisabled: isDisabled,
        isError: false,
        isSelected: false,
        onClick: () => { },
        isAvailable: true
    })
    );

    let { pageTitle, params } = AppStore.lastPageInfo;
    let returnParams = '';
    // @ts-ignore
    if (pageTitle === 'users' && params != null && params.page != null)
        // @ts-ignore
        returnParams = `?page=${params.page}`;

    result.unshift({
        id: 'back',
        linkTo: `${window.SmrLocation}/users${returnParams}`,
        title: 'Назад',
        icon: 'us-back-menu',
        isDisabled: false,
        isError: false,
        isSelected: true,
        onClick: () => { },
        isAvailable: true
    });

    return result;
};